import { render } from "./AddEditPaddle.vue?vue&type=template&id=6615c636&scoped=true"
import script from "./AddEditPaddle.vue?vue&type=script&lang=js"
export * from "./AddEditPaddle.vue?vue&type=script&lang=js"

import "./AddEditPaddle.vue?vue&type=style&index=0&id=6615c636&lang=scss&scoped=true"

import exportComponent from "/Users/emiliedannenberg/Documents/GitHub/nola-paddle-routes/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6615c636"]])

export default __exports__